export const MIGRATED_MENU_KEYS = {
  URL_TOOLS: 'urlTools',
  AB_TEST: 'abTest',
  FORMS: 'forms',
};

export const migratedMenus = {
  [MIGRATED_MENU_KEYS.URL_TOOLS]: {
    title: 'Gerenciamento de URL mudou de endereço',
    descriptionHtml:
      'O gerenciamento de URL (encurtador, edição, personalização, magic link e relatórios) agora fica no <strong>Admin Hub</strong>, em um ambiente dedicado e atualizado.',
    notice:
      'Esta área no Gambit foi desativada. Para continuar usando as ferramentas de URL, acesse o novo admin.',
    redirectUrlProduction:
      'https://admin.empiricus.com.br/tools/url-manager?tab=shortener',
    redirectUrlHml: 'https://admin-hub.emprc.info/tools/url-manager/',
    route: '/ferraments-url',
  },
  [MIGRATED_MENU_KEYS.AB_TEST]: {
    title: 'Gerenciamento de URL mudou de endereço',
    descriptionHtml:
      'O gerenciamento de URL (encurtador, edição, personalização, magic link e relatórios) agora fica no <strong>Admin Hub</strong>, em um ambiente dedicado e atualizado.',
    notice:
      'Esta área no Gambit foi desativada. Para continuar usando as ferramentas de URL, acesse o novo admin.',
    redirectUrlProduction:
      'https://admin.empiricus.com.br/tools/url-manager?tab=shortener',
    redirectUrlHml: 'https://admin-hub.emprc.info/tools/url-manager/',
    route: '/ferraments-url',
  },
  [MIGRATED_MENU_KEYS.FORMS]: {
    title: 'Gerenciamento de Formulários mudou de endereço',
    descriptionHtml:
      'O gerenciamento de formulários do Facebook agora fica no <strong>Admin Hub</strong>, em um ambiente dedicado e atualizado.',
    notice:
      'Esta área no Gambit foi desativada. Para continuar usando formulários, acesse o novo admin.',
    redirectUrlProduction:
      'https://admin.empiricus.com.br/tools/facebook-forms',
    redirectUrlHml: 'https://admin-hub.emprc.info/tools/facebook-forms',
    route: '/facebook',
  },
};

export const getMigratedMenuConfig = (menuKey) => migratedMenus[menuKey];

export const getMigratedMenuRedirectUrl = (menuKey) => {
  const menuConfig = getMigratedMenuConfig(menuKey);

  if (!menuConfig) {
    return '';
  }

  return process.env.NODE_ENV === 'production'
    ? menuConfig.redirectUrlProduction
    : menuConfig.redirectUrlHml;
};

export const getMigratedMenuKeyByRoute = (routePath) => {
  const menuEntry = Object.entries(migratedMenus).find(
    ([, config]) => config.route === routePath,
  );

  return menuEntry ? menuEntry[0] : null;
};



// WEBPACK FOOTER //
// ./src/helpers/migratedMenus.js